import { useDispatch, useSelector } from "react-redux";
import { X } from "lucide-react";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  setSpecialty,
  setSpecialtyList,
} from "@/store/provider-search/provider-search-slice";
import type { RootState } from "@/store/store";
import type { ProviderSearchSpecialtyType } from "@/types";

const SpecialtyListDialog = () => {
  const dispatch = useDispatch();
  const { specialtyList } = useSelector(
    (state: RootState) => state.providerSearch,
  );

  if (specialtyList?.length === 0) return null;

  const onSpecialitySelect = (
    selectedSpeciality: ProviderSearchSpecialtyType,
  ) => {
    dispatch(setSpecialty(selectedSpeciality));
    dispatch(setSpecialtyList([]));
  };

  const onClose = () => {
    dispatch(
      setSpecialty({
        searchParameter: "",
        specialtyDesc: "",
        type: "",
      }),
    );
    dispatch(setSpecialtyList([]));
  };

  return (
    <Dialog defaultOpen={true} onOpenChange={onClose}>
      <DialogContent
        className="px-0 pt-0 sm:max-w-[500px]"
        style={{ maxHeight: "50vh", overflow: "scroll" }}
      >
        <DialogHeader className="sticky top-0 z-10 flex h-12 flex-row items-center justify-between border-b bg-white px-4">
          <DialogTitle>Select a Specialty</DialogTitle>
          <button
            className="cursor-pointer text-gray-500 transition-colors hover:text-gray-700"
            onClick={onClose}
          >
            <X size={20} />
          </button>
        </DialogHeader>
        <div className="space-y-2 px-2">
          {specialtyList?.map(
            (speciality: ProviderSearchSpecialtyType, index: number) => {
              return (
                // 2.1.1 Keyboard — A / 4.1.2 — A: specialities were <div onClick>, so a
                // keyboard user could open the list but choose nothing from it.
                <button
                  type="button"
                  key={`speciality-${index}`}
                  className={`w-full cursor-pointer px-4 py-2 text-left hover:bg-primary-extraLight hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring ${index % 2 ? "bg-white" : "bg-gray-100"}`}
                  onClick={() => onSpecialitySelect(speciality)}
                >
                  <div className="text-medium font-normal">
                    {speciality.specialtyDesc}
                  </div>
                </button>
              );
            },
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SpecialtyListDialog;
